/*SYSTEM IMPORTS*/
import React from 'react'
// import c from 'classnames'

// import Img from "components/Img";
import Link from "components/Link";

// import QuotesIcon from './images/quotes.svg'

import {IsIsset} from "helpers/ValueTests";

import './style'
import './media'


const PartnerItem = props => {
    if( IsIsset(props.to )){
        return(
            <Link className="partner-item" to={props.to}>
                {props.children}
            </Link>
        )
    } else {
        return(
            <div className="partner-item">
                {props.children}
            </div>
        )
    }
}

export default PartnerItem